import $ from 'jquery';
export const hideError = (formEl) => {
    $(formEl).removeClass('form__group--error');
};

export const showError = (formEl, msg) => {
    formEl = $(formEl);
    formEl.addClass('form__group--error');
    if (formEl.find('.form__error_message').length) {
        formEl.find('.form__error_message').text(msg);
        return;
    }
    const errorElement = document.createElement('p');
    errorElement.classList.add('form__error_message');
    errorElement.textContent = msg;
    formEl.append(errorElement);
};
